"use client";

import React from "react";
import styles from "./login.module.css";

import { Card, Button } from "antd";
import Image from "next/image";
import { signIn } from "next-auth/react";

import microsoft from "@/assets/icons/Microsoft.png";
import trek_logo_new from "@/assets/icons/trek_logo_new.svg";
import { useTeamsAuth } from "@/context/TeamsAuthContext";

interface Props {}

const centerFlex: React.CSSProperties = {
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  height: "100vh",
  fontFamily: "sans-serif",
};

const Login: React.FC<Props> = () => {
  // Single source of truth for Teams SSO — handled by TeamsAuthProvider in _app.tsx.
  // The Login component no longer runs its own competing SSO flow.
  const { inTeams, loading: teamsLoading, error: teamsError } = useTeamsAuth();

  if (inTeams && teamsLoading) {
    return (
      <div style={{ ...centerFlex, color: "#FE5000" }}>
        Signing you in with Microsoft Teams…
      </div>
    );
  }

  if (inTeams && teamsError) {
    return (
      <div
        style={{
          ...centerFlex,
          flexDirection: "column",
          gap: 16,
          padding: 32,
          textAlign: "center",
          maxWidth: 560,
          margin: "0 auto",
        }}
      >
        <span style={{ fontSize: 18, fontWeight: 600, color: "#FE5000" }}>
          Teams sign-in could not be completed
        </span>
        <div
          style={{
            background: "#fff7f0",
            border: "1px solid #FE5000",
            borderRadius: 8,
            padding: "12px 16px",
            textAlign: "left",
            width: "100%",
            fontSize: 12,
            color: "#555",
          }}
        >
          {teamsError}
        </div>
        <Button
          size="large"
          type="primary"
          style={{ backgroundColor: "#FE5000", borderColor: "#FE5000", marginTop: 8 }}
          onClick={() => signIn("azure-ad")}
        >
          <span style={{ marginRight: 6 }}>Sign in with Microsoft</span>
          <Image src={microsoft} alt="Microsoft" width={14} height={14} />
        </Button>
      </div>
    );
  }

  // Standard web sign-in card (browser flow)
  return (
    <Card style={{ width: "33%", height: "52%" }} className={styles.loginForm}>
      <div className={styles.imageLogo}>
        <div
          style={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
            width: "30%",
          }}
        >
          <Image
            src={trek_logo_new}
            width={700}
            height={70}
            alt="Trek logo"
            className={styles.imageKnow}
            style={{
              mixBlendMode: "multiply",
              backgroundColor: "transparent",
              marginLeft: "85%",
            }}
          />
        </div>
      </div>
      <div>
        <label className={styles.fontLabel}>Sign in using Microsoft credentials</label>
        <Button
          size="large"
          type="primary"
          htmlType="submit"
          block
          style={{ backgroundColor: "#FE5000", borderColor: "#FE5000", marginTop: "5%" }}
          onClick={(e) => {
            e.preventDefault();
            signIn("azure-ad");
          }}
        >
          <div
            className={styles.signInClass}
            style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
          >
            <span style={{ marginRight: "5px" }}>Sign in </span>
            <Image
              src={microsoft}
              alt="Microsoft"
              width={12}
              height={12}
              style={{ height: "min-content" }}
            />
          </div>
        </Button>
        <div
          style={{
            color: "black",
            fontFamily: "'Poppins', sans-serif",
            fontWeight: "200",
            fontSize: "70%",
            marginTop: "20%",
          }}
        />
      </div>
    </Card>
  );
};

export default Login;
